module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1019-394ff646c5eff79f537f1c05b1382596.png";